// extracted by mini-css-extract-plugin
export default {"powered-by":"styles_powered-by__dI3ux","powered-by--non-live":"styles_powered-by--non-live__va8HJ","powered-by__logo":"styles_powered-by__logo__pibN3"};